export default function PrivacyPolicy() {
  return (
    <div className="container__policy">
      <h1>Privacy Policy</h1>
      <p>
        AI & Tech Today respects your privacy.

## Information We Collect
We may collect limited personal information such as your email address if you contact us directly. We do not sell or share personal information with third parties except as required to operate this website.

## Cookies & Advertising
AI & Tech Today uses Google AdSense to display advertisements. Google and its partners may use cookies to show ads based on your visits to this and other websites.

You can opt out of personalized advertising by visiting:
https://adssettings.google.com
</p>
      <p>
        ## Third-Party Services
Third-party vendors, including Google, may use cookies or web beacons to collect information as part of ad serving.

## Contact
If you have questions about this policy, contact us at:
forosho89@gmail.com
      </p>
    </div>
  );
}